<template>
  <div class="home">
    <Nav />
    <!-- 轮播 -->
    <div class="swrper">
      <el-carousel height="">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <img :src="item.image" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 产品优势 -->
    <div class="ProductAdvantage wow animate__animated animate__bounceInLeft animate__delay-1s">
      <div class="top_title">
        <h1>产品优势</h1>
        <span>Product advantages</span>
      </div>
      <div class="ProductAdvantage_list">
        <div class="_li" v-for="(item, index) in ProductAdvantageList" :key="index">
          <h3>{{item.h1}}</h3>
          <img :src="item.img" alt="">
          <span>{{item.span}}</span>
        </div>
      </div>
    </div>
    <!-- 满足多种需求 -->
    <div class="MeetMultipleNeeds wow animate__animated animate__bounceInRight animate__delay-1s">
      <div class="top_title">
        <h1>满足多种需求</h1>
        <span>Meet multiple needs</span>
      </div>
      <div class="_cont">
        <div class="_top_title">
          步峰HTTP作为企业级大数据爬取服务提供商，我们已与多家公司达成合作， 针对不同企业提供相应的定制服务。您的需求，我们会竭尽全力为您解决。
        </div>
        <div class="_list">
          <div class="_li"><span>1</span>支持高并发并调用</div>
          <div class="_li"><span>2</span>终端数量不限制</div>
          <div class="_li"><span>3</span>自建机房纯净网络</div>
          <div class="_li"><span>4</span>海量资源可调用</div>
        </div>
        <!-- <div class="_bot">
          <h2>准备好开始使用了吗？</h2>
          <div class="_bot_list">
            <p @click.stop="jumpPackage()">免费体验</p>
            <p @click.stop="jumpscroll()">申请试用</p>
          </div>
        </div> -->
      </div>
    </div>
    <!-- 节点 -->
    <div class="allNode wow animate__animated animate__bounceInLeft animate__delay-1s" style="display:none;">
      <div class="top_title">
        <h1>遍布全国节点</h1>
        <span>All over the country node layout</span>
      </div>
      <div class="_cont">
        <div class="_left">
          <li>
            <span class="num">{{num1}}</span><span>自营优质节点</span>
          </li>
          <li>
            <span class="num">{{num2}}w+</span><span>每日使用次数</span>
          </li>
          <li>
            <span class="num">{{num3}}w+</span><span>去重可用IP量</span>
          </li>
        </div>
        <div class="_right">
          <div class="map">
            <li v-for="index in 15" :key="index" :class="'pulse css_' + index" ></li>
           
          </div>
        </div>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div class="partners wow animate__animated animate__bounceInRight animate__delay-1s" >
      <div class="top_title">
        <h1>合作伙伴</h1>
        <span>Cooperative partner</span>
      </div>
      <div class="_cont">
        <div class="_top_title">
          携手共赢，与全球合作伙伴共建大数据新生态加入步峰大数据生态合作伙伴计划， 开创新业务，获取折扣、技术、资源，实现更快速成长
        </div>
        <div class="_list">
          <li 
          class="_li" 
          v-for="(item, index) in partnerList" 
          :key="index"><img :src="item.img" alt=""></li>
        </div>
      </div>
    </div>
    <!-- 联系我们 -->
    <!-- <div id="contact_us" class="Contact wow animate__animated animate__bounceInLeft animate__delay-1s">
      <div class="top_title">
        <h1>联系我们</h1>
        <span>Contact us</span>
      </div>
      <div class="_cont">
       <div class="_left">
          <div class="magnifier">
            <div class="magnifier-box">
              <pic-zoom :url="info.src" :scale="3"></pic-zoom>
            </div>
          </div>
          <p class="_bot">公司于2018年获得国家颁布的《中国人民共和国增值电信业务经营许可证》(ICP)是目前国内<span class="_span">仅有</span>的五家被认证的虚拟专用网业务 覆盖全国的企业</p>
       </div>
       <div class="_right">
          <img class="_img" src="../assets/kfEwm013.png" alt="">
          <p class="_title">如需详细了解或特殊定制，请联系步峰代理的售前顾问</p>
       </div>
      </div>
     
    </div> -->
    <Foot />
  </div>
</template>

<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import { WOW } from 'wowjs' 
import Foot from '@/components/Foot.vue'
import { request } from "../css/request.js";
import { Apis } from "../css/Api.js";
// import PicZoom  from './PicZoom.vue'
// import imgZoom from 'vue2.0-zoom'
import PicZoom from 'vue-piczoom'
export default {
  name: 'Home',
  components: {
    Nav,
    Foot,
    // imgZoom
    PicZoom
  },
  watch: {
    cases() {
      this.$nextTick(() => { // 在dom渲染完后,再执行动画
        var wow = new WOW({
          boxClass: 'wow',
          animateClass: 'animated',
          offset: 0,
          mobile: true,
          live: true
        });
        wow.init();
      })
    }
  },
  data(){
    return {
      // configs: {
      //   width:300,
      //   height:435,
      //   maskWidth:100,
      //   maskHeight:100,
      //   maskColor:'red',
      //   maskOpacity:0.2
      // },
      info:{
        src:require('../assets/zzimg.jpg')
      },
      ProductAdvantageList:[
        {h1:'极速稳定',img:require('../assets/home_list_1.png'),span:'自有机房独享带宽，秒拨数百万IP库，海量IP资源，覆盖全国城市，全国线路任选，线路绿色纯净高质量，全网畅享，安全稳定，快速流畅。'},
        {h1:'安全便捷',img:require('../assets/home_list_2.png'),span:'每日提取数量及使用不限制，IP数自定义，请求时间< 3秒， 支持自动切换IP、过滤重复IP、自动清除cookies，安全稳定高匿名，全程无后顾之忧。'},
        {h1:'品质保障',img:require('../assets/home_list_3.png'),span:'专业技术团队7*24小时不间断维护提供IP支持，保障代理服务器的持续稳定运行，创造稳定易用经济安全的用户体验。'},
      ],
      partnerList:[
        {img:require('../assets/logo1.png')},
        {img:require('../assets/tuceng15.png')},
        {img:require('../assets/tuceng16.png')},
        {img:require('../assets/tuceng17.png')},
        {img:require('../assets/tuceng18.png')},
        {img:require('../assets/tuceng19.png')},
        {img:require('../assets/tuceng20.png')},
        // {img:require('../assets/tuceng21.png')},
        {img:require('../assets/tuceng22.png')},
        {img:require('../assets/tuceng23.png')},
        {img:require('../assets/tuceng24.png')},
        {img:require('../assets/tuceng25.png')},
        {img:require('../assets/tuceng1121.png')},
        {img:require('../assets/tuceng1122.png')},
        {img:require('../assets/tuceng1123.png')},
      ],
      bannerList:[],
      num1:0,
      num2:0,
      num3:0,
      interNum1:null,
      interNum2:null,
      interNum3:null,
    }
  },
  created(){
    this.getBannerList()
    if(this.interNum1 == null){
      this.interNum1 = setInterval(function(){
        this.num1 = this.num1 + 125
        if(this.num1 >= 10000){
          clearInterval(this.interNum1);
          this.num1 = '1w+'
          return
        }
      }.bind(this), 100);
    }
    if(this.interNum2 == null){
      this.interNum2 = setInterval(function(){
        this.num2 = this.num2 + 3
        if(this.num2 >= 300){
          clearInterval(this.interNum2);
          return
        }
      }.bind(this), 100);
    }
    if(this.interNum3 == null){
      this.interNum3 = setInterval(function(){
        this.num3 = this.num3 + 2
        if(this.num3 >= 200){
          clearInterval(this.interNum3);
          return
        }
      }.bind(this), 100);
    }
  },
  methods:{
    jumpscroll(){
      document.querySelector("#contact_us").scrollIntoView(true);
    },
    jumpPackage(){
      this.$router.push({ path: '/package' })
    },
    getBannerList(){
      let data = {
        type:1
      }
      request({
				method: "get", 
				url: Apis.getBannerList,
				params:data,
        _type:1,
			}).then(res => {
				if(res.code == 0){
					this.bannerList = res.data
				}else{
					this.$message.error(res.msg);
				}
			});
    }
  }

}
</script>
<style lang="less" scoped>
.top_title{
  width: 100%;
  text-align: center;
  position: relative;
  top: 30px;
  span{
    color: #BAC6D2;
    font-size: 22px;
  }
  h1{
    font-size: 36px;
  }
  h1::before {
    content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #51B3FF;
    position: relative;
    top: -5px;
    right: 50px;
  }
  h1::after {
    content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #51B3FF;
    position: relative;
    top: -5px;
    left: 50px;
  }
}
.home{
  width: 100%;
  position: relative;
  .ProductAdvantage{
    width: 100%;
    height: 700px;
    // background: paleturquoise;
    .ProductAdvantage_list{
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;
      padding: 20px;
      ._li{
        width: 30%;
        position: relative;
        top:40px;
        cursor:pointer;
        h3{
          width: 100%;
          margin-top: 60px;
          font-size: 26px;
          text-align: center;
        }
        img{
          width: 260px;
          height: 192px;
          margin: 0 auto;
        }
        span{
          font-size: 17px;
          line-height: 30px;
          margin-top: 20px;
          width: 100%;
          color: #989898;
          text-align: center;
        }
      }
      ._li:hover{
        -webkit-transition: all 0.5s ease;
        -ms-transition: all 0.5s ease;
        -moz-transition: all 0.5s ease;
        transition: all 0.5s ease;
        top:0px;
      }
    }
  }
  .MeetMultipleNeeds{
    width: 100%;
    height: 700px;
    background: url('../assets/753.png')no-repeat;
    background-size: 100% 100%;
    // background: paleturquoise;
    .top_title{
      top: 100px;
    }
    ._cont{
      width: 1200px;
      margin: 0 auto;
      margin-top: 110px;
      padding: 20px;
      // display: flex;
      // justify-content: space-around;
      ._top_title{
        width:610px;
        margin: 0 auto;
        margin-top: 70px;
        text-align: center;
        font-size: 18px;
        color:#5C6872;
      }
      ._list{
        width: 100%;
        margin-top: 65px;
        display: flex;
        justify-content: space-around;
        ._li{
          width: 262px;
          height: 120px;
          border-radius: 20px;
          background: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 24px;
          color: #222121;
          box-shadow: 0px 5px 21px 0px rgba(209, 209, 209, 0.32);
          // cursor:pointer;
          transition: background 1s;
          span{
            transition: color 1s;
            color: #A5D2FF;
            font-size: 44px;
            margin-right: 10px;
          }
        }
        ._li:hover{
          background: #1F8EFF;
          color: #fff;
          span{
            color: #fff;
          }
        }
      }
      ._bot{
        width: 100%;
        margin-top: 66px;
        h2{
          font-size: 46px;
          color: #5C6872;
          font-weight: 300;
        }
        ._bot_list{
          width: 600px;
          margin: 0 auto;
          margin-top: 42px;
          display: flex;
          justify-content: space-around;
          p{
            width: 253px;
            height: 79px;
            border-radius: 100px;
            background: #1F8EFF;
            color: #FFFFFF;
            text-align: center;
            line-height: 79px;
            box-shadow: 0px 5px 21px 0px rgba(81, 179, 255, 0.36);
            font-size: 24px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .allNode{
    width: 100%;
    height: 700px;
    // background: paleturquoise;
    ._cont{
      width: 1200px;
      height: 500px;
      margin: 0 auto;
      margin-top: 20px;
      display: flex;
      justify-content: space-around;
      ._left{
        width: 200px;
        height: 100%;
        li{
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          margin-top: 80px;
          span{
            width: 100%;
            text-align: center;
            color: #1E1D1D;
            font-size: 18px;
            font-weight: 400;
            margin-top: 10px;
          }
          .num{
            width: 100%;
            text-align: center;
            font-size: 48px;
            font-weight: bold;
            line-height: 30px;
            color: #51B3FF;
          }
        }
      }
      ._right{
        width: 750px;
        height: 100%;
        position: relative;
        top: 35px;
        .map{
          width: 100%;
          height: 100%;
          background:url('../assets/map.png')no-repeat;
          background-size: 100% 100%;
          position: absolute;
          top:0;
          left: 0;
        }
      }
    }
  }
  .partners{
    width: 100%;
    height: 694px;
    background: #F3F3F3;
    ._cont{
      width: 1200px;
      margin: 0 auto;
      // margin-top: 20px;
      ._top_title{
        width: 592px;
        margin: 0 auto;
        position: relative;
        top: 70px;
        text-align: center;
        font-size: 18px;
        color: #5C6872;
      }
      ._list{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        position: relative;
        top: 80px;
        ._li{
          width: 212px;
          height: 100px;
          margin: 0 14px;
          margin-top: 40px;
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
      // margin-top: 20px;
    }
  }
  .Contact{
    width: 100%;
    ._cont{
      width: 1200px;
      height: 300px;
      margin: 0 auto;
      position: relative;
      top: 50px;
      margin-bottom: 20px;
      display: flex;
      ._right{
        width: 50%;
        ._title{
          width: 100%;
          text-align: center;
          font-size: 16px;
           margin-top: 30px;
        }
        ._img{
          width: 140px;
          height: 140px;
          margin: 0 auto;
          margin-top: 20px;
        }
      }
      ._left{
        width: 50%;
        ._bot{
          width: 592px;
          margin: 0 auto;
          margin-top: 20px;
          font-size: 16px;
          ._span{
            color: #51B3FF;
          }
        }
        .magnifier{
          width: 120px;
          // height: 1000px;
          margin: 0 auto;
          // position: relative;
          top: -20px;
          .magnifier-box{
            width: 120px;
            height: 174px;
            position: relative;
            .vertical{
              img{
                width: 100%!important;
              }
            }
          }
        }
      }
    }
    
  }
}

.pulse{
  background: rgb(37, 148, 238);
  border-radius: 50%;
  height: 10px;
  width: 10px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: 11px 0px 0px -12px;
  z-index: 1
}
.pulse:after {
  content: "";
  border-radius: 50%;
  height: 40px;
  width: 40px;
  position: absolute;
  margin: -15px 0 0 -20px;
  -webkit-animation: pulsate 1s ease-out;
  -moz-animation: pulsate 1s ease-out;
  -o-animation: pulsate 1s ease-out;
  -ms-animation: pulsate 1s ease-out;
  animation: pulsate 1s ease-out;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  -o-animation-iteration-count: infinite;
  -ms-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  opacity: 0;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  filter: alpha(opacity=0);
  -webkit-box-shadow: 0 0 1px 2px #00e1ff;
  box-shadow: 0 0 1px 2px #367bfb;
  -webkit-animation-delay: 1.1s;
  -moz-animation-delay: 1.1s;
  -o-animation-delay: 1.1s;
  -ms-animation-delay: 1.1s;
  animation-delay: 1.1s;
}
@-moz-keyframes pulsate {
  0% {
    -webkit-transform: scale(0.1, 0.1);
    -moz-transform: scale(0.1, 0.1);
    -o-transform: scale(0.1, 0.1);
    -ms-transform: scale(0.1, 0.1);
    transform: scale(0.1, 0.1);
    opacity: 0;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    filter: alpha(opacity=0);
  }
  50% {
    opacity: 1;
    -ms-filter: none;
    filter: none;
  }
  100% {
    -webkit-transform: scale(1.2, 1.2);
    -moz-transform: scale(1.2, 1.2);
    -o-transform: scale(1.2, 1.2);
    -ms-transform: scale(1.2, 1.2);
    transform: scale(1.2, 1.2);
    opacity: 0;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    filter: alpha(opacity=0);
  }
}
@-webkit-keyframes pulsate {
  0% {
    -webkit-transform: scale(0.1, 0.1);
    -moz-transform: scale(0.1, 0.1);
    -o-transform: scale(0.1, 0.1);
    -ms-transform: scale(0.1, 0.1);
    transform: scale(0.1, 0.1);
    opacity: 0;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    filter: alpha(opacity=0);
  }
  50% {
    opacity: 1;
    -ms-filter: none;
    filter: none;
  }
  100% {
    -webkit-transform: scale(1.2, 1.2);
    -moz-transform: scale(1.2, 1.2);
    -o-transform: scale(1.2, 1.2);
    -ms-transform: scale(1.2, 1.2);
    transform: scale(1.2, 1.2);
    opacity: 0;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    filter: alpha(opacity=0);
  }
}
@-o-keyframes pulsate {
  0% {
    -webkit-transform: scale(0.1, 0.1);
    -moz-transform: scale(0.1, 0.1);
    -o-transform: scale(0.1, 0.1);
    -ms-transform: scale(0.1, 0.1);
    transform: scale(0.1, 0.1);
    opacity: 0;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    filter: alpha(opacity=0);
  }
  50% {
    opacity: 1;
    -ms-filter: none;
    filter: none;
  }
  100% {
    -webkit-transform: scale(1.2, 1.2);
    -moz-transform: scale(1.2, 1.2);
    -o-transform: scale(1.2, 1.2);
    -ms-transform: scale(1.2, 1.2);
    transform: scale(1.2, 1.2);
    opacity: 0;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    filter: alpha(opacity=0);
  }
}
@keyframes pulsate {
  0% {
    -webkit-transform: scale(0.1, 0.1);
    -moz-transform: scale(0.1, 0.1);
    -o-transform: scale(0.1, 0.1);
    -ms-transform: scale(0.1, 0.1);
    transform: scale(0.1, 0.1);
    opacity: 0;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    filter: alpha(opacity=0);
  }
  50% {
    opacity: 1;
    -ms-filter: none;
    filter: none;
  }
  100% {
    -webkit-transform: scale(1.2, 1.2);
    -moz-transform: scale(1.2, 1.2);
    -o-transform: scale(1.2, 1.2);
    -ms-transform: scale(1.2, 1.2);
    transform: scale(1.2, 1.2);
    opacity: 0;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    filter: alpha(opacity=0);
  }
}
.css_1{
  left: 64.5%;
  top: 38.5%;
}
.css_2{
  left: 42.5%;
  top: 64.5%;
}
.css_3{
  left: 57.6%;
  top: 69%;
}
.css_4{
  left: 73.5%;
  top: 60.5%;
}
.css_5{
  left: 70%;
  top: 54%;
}
.css_6{
  left: 70%;
  top: 75%;
}
.css_7{
  left: 65%;
  top: 71%;
}
.css_8{
  left: 72%;
  top: 44%;
}
.css_9{
  left: 60%;
  top: 56%;
}
.css_10{
  left: 76%;
  top: 17%;
}
.css_11{
  left: 54%;
  top: 51%;
}
.css_12{
  left: 55%;
  top: 92%;
}
.css_13{
  left: 62%;
  top: 82%;
}
.css_14{
  left: 77%;
  top: 29%;
}
.css_15{
  left: 38%;
  top: 37%;
}
</style>
<style scoped>
/*     left: 897px;
    top: 3348px; */

  .swrper >>> .el-carousel__container{
    height: calc(100vh - 220px);
  }
  .swrper >>> .el-carousel__container img{
    width: 100%;
    height: 100%;
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }
  .swrper >>> .el-carousel__item:nth-child(2n) {
     background-color: #99a9bf;
  }
  .swrper >>> .el-carousel__item:nth-child(2n+1) {
     background-color: #d3dce6;
  }

  /* 媒体查询 */
  @media screen and (max-width: 1200px) {
    .swrper >>> .el-carousel__container{
      height: calc(100vh - 320px);
    }
  }
</style>
<style lang="less">
.magnifier-box .vertical{
  // position: relative;
  img{
    width: 100%!important;
  }
}
.mouse-cover-canvas{
  // left: 60%!important;
  // // top: 3300px!important;
  // top:10vw!important;
  left: 40%!important;
  top: 3055px!important;
}
.magnifier-box .mouse-cover{
  background: none!important;
}
@media screen and (max-width: 1200px) {
  .mouse-cover-canvas{
   
    left: 33%!important;
    top: 2888px!important;
  }
}
</style>